import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import Icon from './Icon';
import '../css/dev-notice.css';

/**
 * Уведомление при входе на страницу, которая ещё на заглушках.
 * Закрывается одной кнопкой «Понятно».
 */
const DevNotice = ({ title, text }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    if (open) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="dev-modal-backdrop" role="presentation">
      <div className="dev-modal" role="alertdialog" aria-modal="true" aria-labelledby="dev-modal-title">
        <span className="dev-modal-icon">
          <Icon name="alert-triangle" size={28} />
        </span>
        <h2 className="dev-modal-title" id="dev-modal-title">{title || t('devNotice.title')}</h2>
        <p className="dev-modal-text">{text || t('devNotice.text')}</p>
        <button type="button" className="dev-modal-btn" onClick={() => setOpen(false)} autoFocus>
          {t('devNotice.button')}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default DevNotice;
